module.exports = (__webpack_require__(22987))(80);